import { Locales } from "i18n/country";
import { loadServerTranslations } from "../i18n/messages";
import PrivacyHub from "./[lang]/privacy-hub";

export default PrivacyHub;

export const getStaticProps = async () => {
  const locale = Locales.USA;

  return {
    props: {
      locale,
      messages: await loadServerTranslations(locale, ["common", "page-privacy-hub"]),
    },
    revalidate: 60,
  };
};
